import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'

import {useAuthUser} from 'react-auth-kit'
import {useIntl} from 'react-intl'
import {useCreateTerminal} from 'src/feature/terminal/context/useMutation'

export default function TerminalForm() {
  const intl = useIntl()
  const auth = useAuthUser()
  const {isLoading, mutateAsync} = useCreateTerminal()

  const validSchema = Yup.object({
    deviceModel: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    manufacturer: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    deviceOS: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    deviceLabel: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    serialNumber: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    oneTimePasscode: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    assignedBuildNumber: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    applicationSign: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    buildNumber: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    mccCode: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    no: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    tokenCode: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
  })

  const onSubmit = async (values, {setSubmitting, resetForm}) => {
    await mutateAsync({values})
    setSubmitting(false)
  }

  return (
    <Formik
      // enableReinitialize
      initialValues={{
        deviceModel: '',
        manufacturer: '',
        deviceOS: '',
        deviceLabel: '',
        serialNumber: '',
        oneTimePasscode: '',
        assignedBuildNumber: '',
        applicationSign: '',
        buildNumber: '',
        mccCode: '',
        // storeId: '996225251718',
        storeId: '',
        userID: auth().id,
        storeNo: '',
        id: '',
        no: '',
        tokenCode: '',
      }}
      validationSchema={validSchema}
      onSubmit={onSubmit}
    >
      {({errors, touched}) => (
        <Form className='form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework'>
          <input type='hidden' name='id' />
          <input type='hidden' name='no' />
          <input type='hidden' name='storeId' />
          <input type='hidden' name='storeNo' />
          <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
            <div className='tab-content'>
              <div
                className='tab-pane fade active show'
                id='kt_ecommerce_add_terminal_general'
                role='tabpanel'
              >
                <div className='d-flex flex-column gap-7 gap-lg-10'>
                  <div className='card card-flush py-4'>
                    <div className='card-header'>
                      <div className='card-title'>
                        <h2>General</h2>
                      </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className='mb-10 fv-row fv-plugins-icon-container'>
                        <div className='row mb-5'>
                          <div className='col-6 mb-8'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.MANUFACTURER'})}
                            </label>

                            <Field
                              type='text'
                              name='manufacturer'
                              className='form-control mb-2'
                              placeholder='Manufacturer'
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault()
                                }
                              }}
                            />
                            {errors.manufacturer && touched.manufacturer ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  {errors.manufacturer.toString()}
                                </div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-6 mb-8'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.TERMINAL_NO'})}
                            </label>

                            <Field
                              type='text'
                              name='no'
                              className='form-control mb-2'
                              placeholder='TPN No'
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault()
                                }
                              }}
                            />
                            {errors.no && touched.no ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.no}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.DEVICE_MODEL'})}
                            </label>

                            <Field
                              type='text'
                              name='deviceModel'
                              className='form-control mb-2'
                              placeholder='Device Modal'
                            />
                            {errors.deviceModel && touched.deviceModel ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.deviceModel}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.DEVICE_OS'})}
                            </label>

                            <Field
                              type='text'
                              name='deviceOS'
                              className='form-control mb-2'
                              placeholder='Device OS'
                            />
                            {errors.deviceOS && touched.deviceOS ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.deviceOS}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4 mb-8'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.DEVICE_LABEL'})}
                            </label>

                            <Field
                              type='text'
                              name='deviceLabel'
                              className='form-control mb-2'
                              placeholder='Device Label'
                            />
                            {errors.deviceLabel && touched.deviceLabel ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.deviceLabel}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.SERIAL_NUMBER'})}
                            </label>

                            <Field
                              type='text'
                              name='serialNumber'
                              className='form-control mb-2'
                              placeholder='Serial Number'
                            />
                            {errors.serialNumber && touched.serialNumber ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.serialNumber}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.ONE_TIME_PASSCODE'})}
                            </label>

                            <Field
                              type='text'
                              name='oneTimePasscode'
                              className='form-control mb-2'
                              placeholder='One Time Passcode'
                            />
                            {errors.oneTimePasscode && touched.oneTimePasscode ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.oneTimePasscode}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4 mb-8'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.ASSIGNED_BUILD_NUMBER'})}
                            </label>

                            <Field
                              type='text'
                              name='assignedBuildNumber'
                              className='form-control mb-2'
                              placeholder='Assigned Build Number'
                            />
                            {errors.assignedBuildNumber && touched.assignedBuildNumber ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.assignedBuildNumber}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.APPLICATION_SIGN'})}
                            </label>

                            <Field
                              type='text'
                              name='applicationSign'
                              className='form-control mb-2'
                              placeholder='Application Sign'
                            />
                            {errors.applicationSign && touched.applicationSign ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.applicationSign}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.BUILD_NUMBER'})}
                            </label>

                            <Field
                              type='text'
                              name='buildNumber'
                              className='form-control mb-2'
                              placeholder='Build Number'
                            />
                            {errors.buildNumber && touched.buildNumber ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.buildNumber}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-4'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.MCC'})}
                            </label>

                            <Field
                              type='text'
                              name='mccCode'
                              className='form-control mb-2'
                              placeholder='MCC'
                            />
                            {errors.mccCode && touched.mccCode ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.mccCode}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='col-8 mt-8'>
                            <label className='required form-label'>
                              {intl.formatMessage({id: 'TERMINAL.INPUT.TOKEN_CODE'})}
                            </label>

                            <Field
                              type='textarea'
                              name='tokenCode'
                              className='form-control mb-2 resize-none'
                              placeholder='Token Code'
                            />
                            {errors.tokenCode && touched.tokenCode ? (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors.tokenCode}</div>
                              </div>
                            ) : null}

                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'></div>
                          </div>
                          <div className='d-flex justify-content-end px-10 pt-10'>
                            <a href='/terminals' className='btn btn-light me-5'>
                              {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
                            </a>

                            <button type='submit' className='btn btn-primary'>
                              {isLoading ? (
                                <span className='indicator-label'>
                                  {intl.formatMessage({id: 'PLEASE_WAIT'})}{' '}
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              ) : (
                                <span className='indicator-label'>
                                  {intl.formatMessage({id: 'GLOBAL.BUTTON.CREATE'})}
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
